import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { topicGroups } from '@/mocks/tracking';

const chipMap = {
  primary: 'bg-primary-500 text-background-50 hover:bg-primary-400',
  accent: 'bg-accent-500 text-background-50 hover:bg-accent-400',
  secondary: 'bg-secondary-700 text-background-50 hover:bg-secondary-600',
} as const;

const tabActiveMap = {
  primary: 'bg-background-50 text-foreground-950',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
} as const;

export default function TopicWall() {
  const [activeId, setActiveId] = useState(topicGroups[0].id);
  const active = topicGroups.find((g) => g.id === activeId) ?? topicGroups[0];

  return (
    <section id="topics" className="mx-auto max-w-7xl px-4 md:px-6">
      <Reveal>
        <div className="overflow-hidden rounded-lg bg-primary-950 p-5 text-background-100 md:p-8">
          <div className="flex flex-col gap-5 md:flex-row md:items-start md:justify-between">
            <div className="max-w-xl">
              <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">按热度归档</p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">话题墙 · 分区一目了然</h2>
              <p className="mt-3 text-sm leading-relaxed text-background-100/70">
                想快速定位在追的瓜，直接按分区翻墙。每个话题标注当前讨论热度，方便长期关注时回看阶段。
              </p>
            </div>
            <div className="inline-flex rounded-full bg-primary-800 p-1">
              {topicGroups.map((g) => (
                <button
                  key={g.id}
                  type="button"
                  onClick={() => setActiveId(g.id)}
                  className={`whitespace-nowrap rounded-full px-4 py-2 font-label text-xs font-medium transition-colors ${
                    g.id === activeId ? tabActiveMap[g.tone] : 'text-background-100/70 hover:text-background-50'
                  }`}
                >
                  {g.name}
                </button>
              ))}
            </div>
          </div>

          <div className="mt-7 border-t border-background-100/10 pt-6">
            <p className="flex items-center gap-2 font-label text-xs text-background-100/60">
              <i className="ri-pushpin-2-line text-accent-400" />
              {active.name} · {active.hint}
            </p>
            <div className="mt-4 flex flex-wrap gap-3">
              {active.tags.map((tag) => (
                <a
                  key={tag.name}
                  href="#topics"
                  className={`flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 font-label text-sm transition-colors ${chipMap[active.tone]}`}
                >
                  {tag.name}
                  <span className="font-medium opacity-80">{tag.count}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}